<template>
  <div v-if="detailData" class="box">
    <Header></Header>
    <div class="box-cotent">
          <div v-html="detailData.title" class="title"></div>
          <div class="user">
            <div v-html="'作者:'+detailData.author" class="user-personal"></div>
            <div v-html="detailData.releaseTime" class="user-time"></div>
          </div>
          <div v-html="detailData.content" class="content ql-editor" style="padding:12px 0"></div>
    </div>
    <div class="page-change">
      <div  v-if="detailData.nextInfo" @click="pageChange(detailData.nextInfo.id)">上一篇：{{detailData.nextInfo.title}}</div>
      <div  v-if="detailData.nextChapterInfo" @click="pageChange(detailData.nextChapterInfo.id)">下一篇：{{detailData.nextChapterInfo.title}}</div>
    </div>
  </div>
</template>

<script>
import '@/styles/quil.base.css'
import Header from '@/components/Header'
import { getVatDetail, getVatList, afterAndLast } from '@/api/VAT'
export default {
  data () {
    return {
      detailData: null,
      editorOption: {
        modules: {
          toolbar: []
        }
      },
      list: [],
      active: 0,
      id: '',
      activeId: '',
      last: {
        title: '已经是第一篇了'
      },
      next: {
        title: '已经是最后一篇了'
      }
    }
  },
  components: { Header },
  created () {
    // let phone = navigator.userAgent;//设备机型的相关信息
    // phone = phone.substring(phone.indexOf('(')+1,phone.indexOf(';'));//处理信息，输出iphone
    // console.log(phone,'设备型号--------------')
    // if (phone.indexOf('Windows') != -1) {
    //   window.location.href='https://www.ippmaster.com/'
    // }
    this.id = this.$route.query.id
    if (this.$store.state.vatActive) {
      this.active = this.$store.state.vatActive
    } else if (this.$route.query.active) {
      this.active = this.$route.query.active
    }
    this.activeId = this.$route.query.activeId
    getVatDetail({ id: this.id, type: 1 }).then(res => {
      if (!res || res.code !== 0) {
        return
      }
      this.detailData = res.data
      document.title = res.data.title
    })
    document.documentElement.scrollTop = 0
    // this.getVatList()
    // this.afterAndLast()
  },
  destroyed () {
  },
  methods: {
    /**
     * @description  上一页，下一页 切换
     */
    pageChange (e) {
      if (e.title === '已经是第一篇了' || e.title === '已经是最后一篇了') {
        return
      }
      getVatDetail({ id: e, type: 1}).then(res => {
        if (res) {
          this.detailData = res.data
          document.title = res.data.title
          document.documentElement.scrollTop = 0
          this.id = e
          // this.afterAndLast()
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    /**
     * @description tab切换
     */
    tabChange (e) {
      this.$router.push({
        path: '/VAT',
        query: {
          active: e
        }
      })
      this.$store.state.vatActive = e
    },
    /**
     * @description 获取tab
     */
    getVatList () {
      getVatList().then(res => {
        if (res) {
          let a = {
            title: '全部',
            id: ''
          }
          res.unshift(a)
          this.list = res
        } else {
          this.$toast.fail(res.msg)
        }
      })
    },
    /**
     * @description 获取上一页下一页
     */
    afterAndLast () {
      let a = {
        categoryId: this.activeId,
        articleId: this.id
      }
      afterAndLast(a).then(res => {
        if (res) {
          if (res.last) {
            this.last = res.last
          } else {
            this.last.title = '已经是第一篇了'
          }
          if (res.next) {
            this.next = res.next
          } else {
            this.next.title = '已经是最后一篇了'
          }
        } else {
          this.$toast.fail(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.user {
  display: flex;
  justify-content: space-between;
  margin: 0.5rem 0;
}
.content {
  text-align: left;
  width: 100%;
}
::v-deep .content img {
    max-width: 100%;
  }
.box-cotent {
  margin-top: 1rem;
  padding: 0 .37rem;
}
.title {
  font-size: 0.4rem;
  text-align: left;
  margin-top: 0.2rem;
  font-weight: 500;
  color: #0F0F0F;
}
.page-change{
  display: flex;
  justify-content: space-between;
  padding: 0 0.2rem;
  margin-bottom: 0.3rem;
  font-size: 0.22rem;
}
.page-change div{
  width: 45%;
  word-wrap: break-word;word-break: break-all;overflow: hidden;
}
.page-change div:nth-child(1){
  text-align: left;
}
.page-change div:nth-child(2){
  text-align: right;
}
.box{
  padding-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/Vat/vatDetail.vue